class HKMegaMenu extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    this.abortController = new AbortController();
    const options = { signal: this.abortController.signal };
    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('summary');
    this.panel = this.querySelector('.hk-mega__content');
    this.desktop = matchMedia('(min-width: 990px)');
    this.hover = matchMedia('(hover: hover) and (pointer: fine)');
    this.addEventListener('pointerenter', (event) => {
      this.cancelTimers();
      if (event.pointerType !== 'mouse' || !this.desktop.matches || !this.hover.matches) return;
      const focusedMenu = document.activeElement?.closest('hk-mega-menu');
      if (focusedMenu && focusedMenu !== this) return;
      this.openTimer = setTimeout(() => this.open('hover'), 120);
    }, options);
    this.addEventListener('pointerleave', (event) => {
      this.cancelTimers();
      if (event.pointerType !== 'mouse' || this.mode !== 'hover') return;
      this.closeTimer = setTimeout(() => {
        if (!this.matches(':hover') && !this.contains(document.activeElement)) this.close();
      }, 280);
    }, options);
    this.panel.addEventListener('pointerenter', () => this.cancelTimers(), options);
    this.summary.addEventListener('click', (event) => {
      event.preventDefault();
      this.cancelTimers();
      if (this.details.open && this.mode !== 'hover') this.close();
      else this.open(event.detail === 0 ? 'keyboard' : 'click');
    }, options);
    this.addEventListener('focusin', () => this.cancelTimers(), options);
    this.addEventListener('focusout', () => {
      this.closeTimer = setTimeout(() => {
        if (!this.contains(document.activeElement) && !this.matches(':hover')) this.close();
      }, 0);
    }, options);
    this.summary.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        this.open('keyboard');
        const links = this.panel.querySelectorAll('a[href]');
        (event.key === 'ArrowDown' ? links[0] : links[links.length - 1])?.focus();
      }
    }, options);
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.details.open) {
        event.preventDefault();
        event.stopPropagation();
        this.close(true);
      }
    }, options);
    this.querySelector('.hk-mega__close').addEventListener('click', () => this.close(true), options);
    document.addEventListener('pointerdown', (event) => {
      if (!this.contains(event.target)) this.close();
    }, options);
    this.desktop.addEventListener('change', () => this.close(), options);
    window.addEventListener('resize', () => this.measure(), options);
    window.addEventListener('scroll', () => { if (this.details.open) this.measure(); }, { ...options, passive: true });
    this.details.addEventListener('toggle', () => this.summary.setAttribute('aria-expanded', String(this.details.open)), options);
  }
  cancelTimers() {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
  }
  measure() {
    const header = this.closest('.header-wrapper');
    if (header) this.style.setProperty('--hk-menu-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
  }
  open(mode) {
    if (!this.desktop.matches) return;
    this.cancelTimers();
    if (this.details.open && this.mode !== 'hover' && mode === 'hover') return;
    document.querySelectorAll('hk-mega-menu').forEach((menu) => { if (menu !== this) menu.close(); });
    this.mode = mode;
    this.measure();
    this.details.open = true;
    this.summary.setAttribute('aria-expanded', 'true');
  }
  close(restoreFocus = false) {
    this.cancelTimers();
    if (!this.details) return;
    this.details.open = false;
    this.summary.setAttribute('aria-expanded', 'false');
    this.mode = null;
    if (restoreFocus) this.summary.focus();
  }
  disconnectedCallback() {
    this.cancelTimers();
    this.abortController?.abort();
    this.abortController = null;
  }
}
if (!customElements.get('hk-mega-menu')) customElements.define('hk-mega-menu', HKMegaMenu);
